import React, { useContext, useEffect, useRef, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import List from '../../../commonComponents/lists/List';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import SessionItem from '../SessionItem';
import TextFilter from '../../../commonComponents/lists/filters/TextFilter';
import MarketInfosContext from '../../../contextProviders/MarketInfosContext';
import SessionFilters from './SessionFilters';
import { useDimensions } from '../../../services/customHooks';
import CategoryProp from '../../academy/propTypes/categoryProp';
import CurrencyProp from '../../profile/propTypes/currencyProp';
import PriceRangeProp from '../../academy/propTypes/PriceRangeProp';
import useTrailerTrigger from '../../../services/useTrailerTrigger';
import TrailerModal from '../../../commonComponents/TrailerModal';

function SessionList(props) {
  const {
    t,
    query,
    languages,
    onChange,
    currencies,
    categories,
    onQueryChange,
    priceRange,
  } = props;

  const { isMobile } = useDimensions();
  const [isFiltersMobileOpen, setIsFiltersMobileOpen] = useState(false);
  const tableId = 'sessionList';
  const tableEl = useRef(null);
  const [trailerUrl, closeTrailer] = useTrailerTrigger();

  const handleMobileFilter = () => {
    setIsFiltersMobileOpen(prevState => !prevState);
  };

  const columns = [
    {
      field: 'name',
      textAlign: 'center',
      title: t('academy_name'),
      template: item =>
        renderToStaticMarkup(
          <SessionItem
            key={item._id}
            t={t}
            session={item}
            languages={languages}
            mySessionsMode={false}
            isHostTrainerVisible
            query={query}
            showPromotion
            showTeaserVideo
          />,
        ),
    },
  ];
  useEffect(() => {
    $('#searchInput').val(query.search);
  }, [query.search]);

  const { marketInfos } = useContext(MarketInfosContext);

  return (
    <>
      <div className="academy-list-search row fix-on-mobile">
        {isMobile && (
          <div className="col-lg-0 col-2 filter-button-shop-container">
            <button type="button" onClick={handleMobileFilter}>
              <i className="fa fa-filter" />
            </button>
          </div>
        )}
        <div className="col-lg-12 col-10 search-container-mobile">
          <TextFilter
            id="searchInput"
            onChange={onChange('search')}
            placeholder={t('search')}
            value={query.search}
          />
        </div>
      </div>
      {isMobile && isFiltersMobileOpen && (
        <SessionFilters
          currencies={currencies}
          languages={languages}
          categories={categories}
          selected={query}
          onPriceChange={onChange}
          onChange={onQueryChange}
          priceRange={priceRange}
        />
      )}
      <List
        ref={tableEl}
        columns={columns}
        id={tableId}
        dataSourceURL="/table/access-session/list"
        dataSourceHeaders={{
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
        }}
        dataSourceParams={{
          populate: ['host', 'trainer'],
          country: marketInfos.localCountry,
          currency: marketInfos.localCurrency,
        }}
        query={{ ...query }}
      />
      <TrailerModal videoUrl={trailerUrl} onClose={closeTrailer} />
    </>
  );
}

SessionList.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  query: PropTypes.shape({
    category: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  onChange: PropTypes.func.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(CategoryProp.propType))
    .isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  priceRange: PropTypes.shape(PriceRangeProp.propType).isRequired,
};

export default translate(SessionList);
